import React from 'react';

import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Button } from '@bringg/react-components';

import styles from './controls.module.scss';

interface Props {
	onZoomIn: () => void;
	onZoomOut: () => void;
}

const Controls = ({ onZoomIn, onZoomOut }: Props) => {
	return (
		<div className={styles.controls}>
			<div className={styles.zoomControls}>
				<Button
					type="ghost"
					onClick={onZoomIn}
					icon={<BringgIcon iconName={BringgFontIcons.Plus} />}
					data-test-id="timeline-zoom-in-button"
					data-clickable="true"
				/>
				<div className={styles.horizontalSeparator} />
				<Button
					type="ghost"
					onClick={onZoomOut}
					icon={<BringgIcon iconName={BringgFontIcons.Minus} />}
					data-test-id="timeline-zoom-out-button"
					data-clickable="true"
				/>
			</div>
		</div>
	);
};

export default Controls;
